import React from 'react';
import './NewsFeed.css';

class NewsFeed extends React.Component {

    constructor(props) {
      super(props);
      this._ref = React.createRef();
      this.state = {
      crypto_news_posts: [{"desc":"Today’s Top Crypto News, Monday October 24th •Crypto-Friendly Rishi Sunak to Become UK Prime Minister Following Truss Exit– CoinDesk “During his time as finance minister, Sunak unveiled plans to turn the country into an international hub for crypto.” •Bitcoin Remains at $19,000. Two Catalysts That Could Finally Spark a Big Move –Barron&#8217;s “Bitcoin and other [&#8230;]","link":"https://marketrebellion.com/news/cryptocurrency/todays-top-crypto-news-monday-october-24th/","title":"Today’s Top Crypto News, Monday October 24th"},{"desc":"Today’s Top Crypto News, Friday October 21st •Tesla Still Holding $218M in Bitcoin — Elon Musk Expects Company to Be Worth More Than Apple and Saudi Aramco Combined– Bitcoin.com “Tesla’s third-quarter balance sheet shows that"},{"desc":"Today’s Top Crypto News, Monday October 24th •Crypto-Friendly Rishi Sunak to Become UK Prime Minister Following Truss Exit– CoinDesk “During his time as finance minister, Sunak unveiled plans to turn the country into an international hub for crypto.” •Bitcoin Remains at $19,000. Two Catalysts That Could Finally Spark a Big Move –Barron&#8217;s “Bitcoin and other [&#8230;]","link":"https://marketrebellion.com/news/cryptocurrency/todays-top-crypto-news-monday-october-24th/","title":"Today’s Top Crypto News, Monday October 24th"},{"desc":"Today’s Top Crypto News, Monday October 24th •Crypto-Friendly Rishi Sunak to Become UK Prime Minister Following Truss Exit– CoinDesk “During his time as finance minister, Sunak unveiled plans to turn the country into an international hub for crypto.” •Bitcoin Remains at $19,000. Two Catalysts That Could Finally Spark a Big Move –Barron&#8217;s “Bitcoin and other [&#8230;]","link":"https://marketrebellion.com/news/cryptocurrency/todays-top-crypto-news-monday-october-24th/","title":"Today’s Top Crypto News, Monday October 24th"},{"desc":"Today’s Top Crypto News, Monday October 24th •Crypto-Friendly Rishi Sunak to Become UK Prime Minister Following Truss Exit– CoinDesk “During his time as finance minister, Sunak unveiled plans to turn the country into an international hub for crypto.” •Bitcoin Remains at $19,000. Two Catalysts That Could Finally Spark a Big Move –Barron&#8217;s “Bitcoin and other [&#8230;]","link":"https://marketrebellion.com/news/cryptocurrency/todays-top-crypto-news-monday-october-24th/","title":"Today’s Top Crypto News, Monday October 24th"}],
        cryptocurrency_posts: []
      }
      this.connectToParent = this.connectToParent.bind(this);
      this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
      this._is_mounted = true;
      this.connectToParent();
    }
    
    componentWillUnmount() {
      this._is_mounted = false;
      window.removeEventListener('message', this.handleMessage);
    }

    handleMessage(e) {
      try {
        let message_json = JSON.parse(e.data);
        if (message_json.crypto_news !== undefined) {
          const clean_crypto_news = message_json.crypto_news.map(article => ({
              title: article.title.replaceAll(/(&#)(\d){1,4}(;){1}/g, function(encoded_character){
                let txt = document.createElement("textarea");
                txt.innerHTML = encoded_character;
                return txt.value;
              }),
              desc: article.desc.replaceAll(/(&#)(\d){1,4}(;){1}/g, function(encoded_character){
                let txt = document.createElement("textarea");
                txt.innerHTML = encoded_character;
                return txt.value;
              }),
              link: article.link,
              // date: article.date
          }));
          if(this._is_mounted && clean_crypto_news.length > 0) {
            this.setState(state => ({
              ...state,
              crypto_news_posts: clean_crypto_news
            }));
          } else {
            console.log('NewsFeed handleMessage attempted to set state when unmounted or no crypto news items were present.')
          }
        } else {

        }
      } catch (error) {
      }
    }

    connectToParent() {
      window.addEventListener('message', this.handleMessage, false);

      window.parent.postMessage(JSON.stringify({message: `iframe-loaded-to-zachs-mr-wp-sandbox.local-to-${process.env.REACT_APP_PARENT_URL}`}), process.env.REACT_APP_PARENT_URL);
      window.parent.postMessage(JSON.stringify({message: 'iframe-loaded-to-zachs-mr-wp-sandbox.local-to-*'}), '*');
      return null;
    }

    render() {
      let newsfeed_key = `${this.state.crypto_news_posts.join('-')}`;
      

      return (
        <div id='newsfeed-container' key={newsfeed_key}>
          <div id='newsfeed-title-container'>
            <h3 id='newsfeed-title'>Newsfeed</h3>
          </div>
          <div id='crypto-news-posts'>
            {
              this.state.crypto_news_posts.map((crypto_news, index) => {
                let crypto_news_bullets = crypto_news.desc.split('•');
                let crypto_news_title = crypto_news_bullets.shift();
                return (
                  <div key={index} className='news-story-container'>
                    <p className='news-story-title'>{crypto_news_title}</p>
                    <ul>
                      {crypto_news_bullets.map(bullet => {
                        return (<React.Fragment key={bullet}><li className='news-story-point'>
                          {bullet}
                        </li><br/></React.Fragment>)
                      })}
                      <li><p 
                            className='crypto-news-link'
                            onClick={() => {
                              window.open(crypto_news.link, '_blank');
                            }}>
                              More...</p>
                          </li>
                    </ul>
                    
                  </div>
                  )
              })
            }
          </div>
        </div>
      );
    }
}

export default NewsFeed;